// extracted by mini-css-extract-plugin
export var body = "_ox-8";
export var button = "_ox-0";
export var closeButton = "_ox-5";
export var content = "_ox-3";
export var empty = "_ox-f";
export var grid = "_ox-c";
export var header = "_ox-4";
export var icon = "_ox-1";
export var option = "_ox-d";
export var optionSelected = "_ox-e";
export var overlay = "_ox-2";
export var searchIcon = "_ox-a";
export var searchInput = "_ox-b";
export var searchWrapper = "_ox-9";
export var title = "_ox-6";
export var visuallyHidden = "_ox-7";